import { useSearch } from "@tanstack/react-router";
import { AppointmentPaymentSuccessCard } from "~/features/appointments/components/payment-card";

export function AppointmentConfirmationPage() {
  const { appointment_id } = useSearch({ from: "/(dashboard)/dashboard/weight-loss/appointments/confirmation" })

  return (
    <AppointmentPaymentSuccessCard appointment_id={appointment_id ?? ""} />
  );
}
